import { MenuItem, Select } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"

import { ShipToLocationCell } from "@/components/table"
import type { PriorityStatus, ProductSourceChangeAffectedCustomer } from "@/graphql/codegen/graphql"
import { PRIORITY_STATUS_LABELS, PRIORITY_STATUS_OPTIONS } from "@/screens/CustomerProducts/constants"

interface UseAffectedCustomerColumnsProps {
  priorities: Record<string, PriorityStatus>
  onPriorityChange: (id: string, priority: PriorityStatus) => void
}

export const useAffectedCustomerColumns = ({
  priorities,
  onPriorityChange,
}: UseAffectedCustomerColumnsProps): ColumnDef<ProductSourceChangeAffectedCustomer>[] => [
  {
    accessorKey: "company.name",
    header: "Company",
    enableSorting: false,
  },
  {
    accessorKey: "shipToLocation",
    header: "Ship To",
    enableSorting: false,
    cell: ({ row }) => <ShipToLocationCell location={row.original.shipToLocation} />,
  },
  {
    accessorKey: "oldSourcePriority",
    header: "Old Source Priority",
    cell: ({ row }) => PRIORITY_STATUS_LABELS[row.original.priorityStatus],
    enableSorting: false,
  },
  {
    id: "newSourcePriority",
    header: "New Source Priority",
    cell: ({ row }) => (
      <Select
        size='small'
        fullWidth
        value={priorities[row.original.companyProductAssociationLocationId]}
        onChange={(event) =>
          onPriorityChange(row.original.companyProductAssociationLocationId, event.target.value as PriorityStatus)
        }
        data-testid={`source-change.affected-customers.priority-select-${row.original.companyProductAssociationLocationId}`}
      >
        {PRIORITY_STATUS_OPTIONS.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    ),
    enableSorting: false,
  },
]
